import React, { useState } from 'react';
import { AlertTriangle, Trash2, ChevronDown, ChevronRight, XCircle } from 'lucide-react';
import { useErrorLog, ErrorLogEntry } from '../services/errorLog';
function ErrorEntry({
  entry
}: {
  entry: ErrorLogEntry;
}) {
  const [expanded, setExpanded] = useState(false);
  const time = new Date(entry.timestamp);
  return <div className="border border-red-100 bg-white rounded-lg overflow-hidden" data-id="element-4238">
      <button onClick={() => setExpanded(!expanded)} className="w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-red-50/50 transition-colors" data-id="element-4239">
        <XCircle className="h-4 w-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-4240" />
        <div className="flex-1 min-w-0" data-id="element-4241">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-4242">
            <span className="text-sm font-medium text-gray-900" data-id="element-4243">
              {entry.action}
            </span>
            <span className="text-xs text-gray-400" data-id="element-4244">
              {time.toLocaleDateString()} {time.toLocaleTimeString()}
            </span>
          </div>
          <p className="text-sm text-red-700 mt-0.5 font-mono break-all" data-id="element-4245">
            {entry.message}
          </p>
        </div>
        {entry.payload && <div className="flex-shrink-0 mt-0.5" data-id="element-4246">
            {expanded ? <ChevronDown className="h-4 w-4 text-gray-400" data-id="element-4247" /> : <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-4248" />}
          </div>}
      </button>
      {expanded && entry.payload && <div className="border-t border-red-100 bg-gray-900 px-4 py-3 overflow-auto max-h-60" data-id="element-4249">
          <pre className="text-xs text-green-400 font-mono whitespace-pre-wrap break-words" data-id="element-4250">
            {JSON.stringify(entry.payload, null, 2)}
          </pre>
        </div>}
    </div>;
}
export function ErrorLog() {
  const {
    entries,
    count,
    clear
  } = useErrorLog();
  return <div className="space-y-6" data-id="element-4251">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-4252">
        <div className="min-w-0" data-id="element-4253">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-4254">Error Log</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4255">
            Track API errors and failed operations.{' '}
            {count > 0 ? `${count} error${count !== 1 ? 's' : ''} recorded.` : 'No errors recorded.'}
          </p>
        </div>
        {count > 0 && <button onClick={clear} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 whitespace-nowrap flex-shrink-0" data-id="element-4256">
            <Trash2 className="h-4 w-4" data-id="element-4257" />
            Clear All
          </button>}
      </div>

      {/* Error List */}
      {count === 0 ? <div className="bg-white border border-gray-200 rounded-lg p-12 text-center" data-id="element-4258">
          <AlertTriangle className="mx-auto h-12 w-12 text-gray-300" data-id="element-4259" />
          <h3 className="mt-3 text-sm font-semibold text-gray-900" data-id="element-4260">
            No errors
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4261">
            When an API call fails, the error details will appear here.
          </p>
        </div> : <div className="space-y-2" data-id="element-4262">
          {entries.map(entry => <ErrorEntry key={entry.id} entry={entry} data-id="element-4263" />)}
        </div>}
    </div>;
}